import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Notification, STATUS_TYPES } from 'dyl-components';
import "./index.scss"
import importActions from 'actions/import_data';

const POLL_INTERVAL = 10000;
const MAX_FAILED_POLLS = 30;

const Results = ({ module, uploadId, getDataMappingValues, checkIsInLoading, recordsCount }) => {

    const dispatch = useDispatch();

    const [importResults, setImportResults] = useState({});

    const [isLoadingResults, setIsLoadingResults] = useState(false);
    const [isFailedToUpload, setIsFailedToUpload] = useState(false);
    const [failedPoll, setFailedPoll] = useState(false);

    const failedPollCountRef = useRef(0);

    useEffect(() => {
        let timeout;
        let isActive = true;

        const stopPolling = () => {
            setIsLoadingResults(false);
            setIsFailedToUpload(true);
        };

        const fetchResults = async () => {
            try {
                setIsLoadingResults(true)
                if (uploadId) {
                    dispatch(importActions.isReadingImportResults({ upload_id: uploadId })).then(result => {
                        if (!isActive) {
                            return;
                        }
                        if(!result){
                            //API returns no result
                            setFailedPoll(true);
                            return;
                        }
                        if (result.done) {
                            setIsLoadingResults(false)
                            setImportResults(result);
                            return;
                        }
                        if(result && Object.keys(result).length === 0){
                            failedPollCountRef.current += 1;
                            // Give up after MAX_FAILED_POLLS empty responses
                            // (~5 minutes of polling) rather than retrying forever.
                            if (failedPollCountRef.current >= MAX_FAILED_POLLS) {
                                stopPolling();
                                setFailedPoll(true);
                                Notification.alert('Failed to read import results!', STATUS_TYPES.ERROR);
                                return;
                            }
                        }
                        timeout = setTimeout(() => {
                            fetchResults();
                        }, POLL_INTERVAL);
                    }).catch((e) => {
                        console.log(e);
                        if (isActive) {
                            stopPolling();
                            Notification.alert('Failed to read import results!', STATUS_TYPES.ERROR);
                        }
                    });
                }
            } catch (e) {
                console.log(e);
                setIsFailedToUpload(true);
                Notification.alert('Failed to add data mappings!', STATUS_TYPES.ERROR);
            }
        };
        fetchResults();

        return () => {
            isActive = false;
            clearTimeout(timeout);
        };
    }, [uploadId, dispatch]);

    return (
        <div className='Results'>
            <h3 className='Results_Header'>Mapping Results</h3>

            {failedPoll ?
                <p className='Rejected_Records'><b>Failed to upload file</b></p>
            : !uploadId && !isFailedToUpload ? <div>
                <b>Successfully added data mappings!</b>
            </div>
                :
                <div>
                    {checkIsInLoading((isLoadingResults) && !isFailedToUpload) ? <p>Mapping in progress...</p> :
                        <>
                            <p><b>New {module === 'Opportunity' ? 'opportunities' : `${module}s`} created:</b> {importResults?.created || 0}</p>
                            <p><b>Duplicates found:</b> {importResults?.duplicates || 0}</p>
                            {getDataMappingValues('group')?.value !== 'none' && <p><b>Added to group/subgroup:</b> {importResults?.group}</p>}
                            {getDataMappingValues('campaign') !== 'none' && <p><b>Added to campaign:</b>  {importResults?.campaign} </p>}
                            {(importResults?.rejected && !isFailedToUpload) ? <>
                                <hr />
                                <p className='Rejected_Records'><b>Rejected records:</b> {importResults?.rejected}</p>
                            </> :
                                <p><b>Rejected records:</b> {0}</p>
                            }
                            {isFailedToUpload ? <>
                                <hr />
                                <p className='Rejected_Records'><b>System failed to upload:</b> {recordsCount}</p>
                            </> : ""}
                        </>
                    }
                </div>
            }
        </div>
    )
}

export default Results;
